import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { runnerViewAll } from '../../docs-routes'

const RunHistoryIDDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      ID of the test configuration run instance. Useful for identifying a specific test config run.
    </Color>
    <DocusaurusFooter path={runnerViewAll} />
  </Paragraph>

export default RunHistoryIDDescription
